module.exports = __webpack_public_path__ + "audio-aad10886bbb6.m4a";